/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import TaskLists from "./Tasks/TasksLists";
import { EventEmitter } from "../../../services/event.service";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  Dialog,
  DialogContent,
  FormHelperText,
  Tooltip,
} from "@material-ui/core";
import { getuniqueId } from "../../../services/helpers";
import styles from "../clients.module.scss";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CreateClientTask from "./Tasks/CreateClientTask";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import TaskSummary from "./TaskSummary";
import { useMediaQuery } from "@mui/material";
import { useParams } from "react-router";
import { CheckSquare, Plus, X } from "lucide-react";
import { Button } from "../../../components/ui/button";
import DialogComponent from "../../../components/DialogComponent/DialogComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { CommonConfirmationDialog } from "../../../components/DialogComponent/SupplyDataDialog";
// import { Slider } from "../../../components/ui/slider";

/**
 * Converts opentasks variants to "Other Tasks" for display, preserving numbering
 * @param {string} shiftTitle - The shift title from database
 * @returns {string} - Display title
 */
const getDisplayShiftTitle = (shiftTitle) => {
  if (!shiftTitle) return shiftTitle;

  const match = shiftTitle.match(/^opentasks(?:[\s-]+(\d+))?$/i);

  if (match) {
    return match[1] ? `Other Tasks ${match[1]}` : "Other Tasks";
  }

  return shiftTitle;
};

const useStyles = makeStyles((_theme) => ({
  infobutton: {
    borderRadius: "50%",
    border: "1px solid #000",
    width: "18px",
    height: "18px",
    textAlign: "center",
    verticalAlign: "middle",
    cursor: "pointer",
    marginRight: "6px",
    padding: "2px",
    fontSize: "11px",
    lineHeight: "11px",
  },
  disabled: {
    color: "#eee",
    borderColor: "#eee",
    pointerEvent: "none",
  },
  infobuttondanger: {
    borderColor: "#f62d51",
  },

  itemTaskwrap: {
    display: "flex",
    alignItems: "center",
  },
  root: {
    maxWidth: 345,
    minWidth: 120,
  },
  header: {
    background: "#e4e4e4",
    padding: "10px 12px",

    "& span": {
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "20px",
    },
  },
}));

const CreateTaskItem = (props) => {
  const [showTaskChangePopup, setShowTaskChangePopup] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isEditMode, setEditMode] = useState(false);
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState({});
  const [editId, setEditId] = useState();
  const [updatedCustomTask, setUpdatedCustomTask] = useState();
  const [disabledsubSteps, setDisabledSubStep] = useState(2);
  const [toggleCustomTaskForm, setToggleCustomTaskForm] = useState(false);
  const [openAddTaskDialog, setOpenAddTaskDialog] = useState(false);
  const [item, setItem] = useState(null);
  const [frequency, setFrequency] = useState("");
  const [tasks, setTasks] = useState([]);
  const [existingTaskDetails, setExistingTaskDetails] = useState([]);
  const isMobile = useMediaQuery("(max-width:767px)");
  const { clientId } = useParams();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [taskFrequency, setTaskFrequency] = useState(0);

  const onChangeFrequency = (e) => {
    const newfrequency = e.target.value;

    setFrequency(newfrequency);
    setDisabledSubStep(3);
    setErrorMessage({ ...errorMessage, frequency: "" });
  };
  // eslint-disable-next-line no-unused-vars
  const onChangeShift = (e) => {
    // eslint-disable-next-line no-unused-vars
    const newshift = e.target.value;

    setDisabledSubStep(2);
    setErrorMessage({ ...errorMessage, selectedShift: "" });
  };
  const fitfunn = ["Monthly", "Quarterly", "Semi-Annual", "Annually"];

  const fitfunnt = ["Daily", "Weekends", "Weekly", "Bi-Weekly"];
  // const taskOption = props?.settingsData?.[0]?.taskOption;

  // const isAllTasksMode = taskOption === "all_tasks";
  // const isRandomTasksMode = taskOption === "random_tasks";
  // const isSelectedTasksMode = taskOption === "selected_tasks";

  // const pickRandomSubset = (tasks = [], minRatio = 0.4, maxRatio = 0.6) => {
  //   if (!tasks.length) return [];

  //   const min = Math.max(1, Math.floor(tasks.length * minRatio));
  //   const max = Math.max(min, Math.ceil(tasks.length * maxRatio));

  //   const count = Math.floor(Math.random() * (max - min + 1)) + min;

  //   const shuffled = [...tasks].sort(() => 0.5 - Math.random());
  //   return shuffled.slice(0, count);
  // };

  // const applyRandomPOS = (existing = [], incoming = []) => {
  //   if (!incoming.length) return [];

  //   const existingMap = new Map(existing?.map((t) => [(t.taskId ?? t.id), t.pos]));

  //   const existingPosTask = incoming?.find(
  //     (t) => existingMap.get(t.taskId ?? t.id) === true
  //   );

  //   if (existingPosTask) {
  //     const existingPosId =
  //       existingPosTask.taskId ?? existingPosTask.id;

  //     return incoming?.map((t) => ({
  //       ...t,
  //       pos: (t.taskId ?? t.id) === existingPosId,
  //     }));
  //   }

  //   const randomSelected = pickRandomSubset(incoming);

  //   const selectedIds = new Set(randomSelected?.map((t) => t.taskId ?? t.id));

  //   return incoming?.map((t) => ({
  //     ...t,
  //     pos: selectedIds.has(t.taskId ?? t.id),
  //   }));
  // };

  // const setSinglePOSTask = (tasks = [], selectedId) => {
  //   return tasks?.map((t) => {
  //     const id = t.taskId ?? t.id;
  //     return {
  //       ...t,
  //       pos: id === selectedId,
  //     };
  //   });
  // };


  const onEdit = (item) => {
    if (item) {
      setEditMode(true);
      setEditId(item?.id);
      setFrequency(item?.frequency);
      setDisabledSubStep(4);
    }
  };
  useEffect(() => {
    onEdit();
    EventEmitter.subscribe("EditSummaryFrequencyItem", onEdit);
    EventEmitter.subscribe("clearFormCreateTaskGroupItem", clearform);
    return () => {
      EventEmitter.unsubscribe("EditSummaryFrequencyItem", onEdit);
      EventEmitter.unsubscribe("clearFormCreateTaskGroupItem", clearform);
    };
  }, []);

  useEffect(() => {
    if (frequency) {
      const existTask = props?.SummaryList?.filter((item) => {
        if (
          item?.frequency === frequency &&
          item?.shift?.shiftId === props?.shift?.shiftId
        ) {
          return item?.tasks;
        }
        return false;
      });
      const savedTasks = existTask?.[0]?.tasks || [];
      setExistingTaskDetails(savedTasks);

      //   let incomingTasks = props?.standardTasks || [];

      //   const savedTaskMap = new Map(savedTasks?.map((t) => [t.taskId || t.id, t,]));

      //   if (isAllTasksMode) {
      //   incomingTasks = incomingTasks?.map((task) => {
      //     const saved = savedTasks?.find(
      //       (t) => t.id === task.id || t.taskId === task.taskId
      //     );

      //     return {
      //       ...task,
      //       pos: saved ? true : task?.pos ?? false,
      //       posFrequency: saved?.pos ? saved?.posFrequency : 0,
      //     };
      //   });
      // } else if (isRandomTasksMode) {
      //     incomingTasks = applyRandomPOS(savedTasks, incomingTasks);
      // } else if (isSelectedTasksMode) {
      //     incomingTasks = incomingTasks.map((task) => {
      //       const taskKey = task.taskId || task.id;
      //       const saved = savedTaskMap.get(taskKey);

      //       return {
      //         ...task,
      //         pos: saved?.pos === true ? true : false,
      //         posFrequency: saved?.pos === true ? saved?.posFrequency ?? 0 : 0,
      //       };
      //     });
      //   }

      //   props.setStandardTasks(incomingTasks);
      setEditId(existTask?.[0]?.id);
      let taskIds = savedTasks?.map((task) => task?.taskId || task?.id);
      setTasks(taskIds);
      // setTaskFrequency(existTask?.[0]?.taskFrequency || 0);
    }
  }, [frequency]);

  useEffect(() => {
    if (frequency) {
      const customeTask = props?.customtaskList?.filter(
        (item) => item.frequency === frequency
      );
      setUpdatedCustomTask(customeTask);
      // if (customeTask?.length > 0 ) {
      //   setTaskFrequency(customeTask?.[0]?.posFrequency || 0)
      // }
    }
  }, [frequency, props?.customtaskList]);

  const onChangeTask = (event, Task) => {
    const {
      target: { checked },
    } = event;

    const taskIdentifier = Task?.taskId ?? Task?.id;

    // const updateStandardTasks = () => {
    //   props?.setStandardTasks((prev = []) =>
    //     prev.map((item) =>
    //       (item?.taskId ?? item?.id) === taskIdentifier
    //         ? { ...item, pos: false }
    //         : item
    //     )
    //   );
    // };

    if (checked) {
      setTasks((prev = []) =>
        prev.includes(taskIdentifier)
          ? prev
          : [...prev, taskIdentifier]
      );

      // props.setStandardTasks((prev = []) => {
      //   if (isAllTasksMode) {
      //     return prev.map((t) => {
      //       const id = t.taskId ?? t.id;

      //       if (id === taskIdentifier) {
      //         return {
      //           ...t,
      //           pos: true,
      //         };
      //       }

      //       return t;
      //     });
      //   }


      //   if (isRandomTasksMode && checked) {
      //     return setSinglePOSTask(prev, taskIdentifier);
      //   }

      //   return prev.map((t) =>
      //     (t.taskId ?? t.id) === taskIdentifier
      //       ? { ...t, pos: checked }
      //       : t
      //   );
      // });

    } else {
      setTasks((prev = []) =>
        prev.filter((item) => item !== taskIdentifier)
      );
      // updateStandardTasks();
    }

    setErrorMessage((prev) => ({ ...prev, tasks: "" }));
  };


  // eslint-disable-next-line no-unused-vars
  const onCheckTask = (event, task, source) => {
    const { checked } = event.target;
    const taskIdentifier = task.taskId ?? task.id;

    const updater = (list) =>
      list?.map((item) =>
        (item?.taskId ?? item?.id) === taskIdentifier
          ? { ...item, pos: checked }
          : item
      );

    if (source === "selected") {
      props?.setStandardTasks((prev = []) => {
        const exists = prev.some(
          (item) => (item.taskId ?? item.id) === taskIdentifier
        );

        if (!exists) {
          return [...prev, { ...task, pos: checked }];
        }

        return updater(prev);
      });
    }

    if (source === "custom") {
      props?.setCustomTask((prev = []) => {
        const exists = prev?.some((item) => (item.taskId ?? item.id) === taskIdentifier);

        if (exists) {
          return prev.map((item) =>
            (item.taskId ?? item.id) === taskIdentifier
              ? { ...item, pos: checked }
              : item
          );
        }

        return [...prev, { ...task, pos: checked }];
      });
    }
    setErrorMessage({ ...errorMessage, tasks: "" });
  };

  const validateStep = () => {
    let isValid = true;
    let errorMessages = errorMessage;
    if (frequency === "") {
      isValid = false;
      errorMessages = { ...errorMessages, frequency: "Select Frequancy" };
    } else {
      errorMessages = { ...errorMessages, frequency: "" };
    }
    if (
      (typeof tasks === "undefined" || tasks === "" || tasks?.length === 0) &&
      props?.customtaskList?.length === 0
    ) {
      isValid = false;
      errorMessages = { ...errorMessages, tasks: "Select Task/s" };
    } else {
      errorMessages = { ...errorMessages, tasks: "" };
    }
    setErrorMessage(errorMessages);
    return isValid;
  };

  const submitTaskItem = () => {
    let valid = validateStep();
    if (!valid) return;
    const taskIdSet = new Set(tasks);

    const selectedStandardTasks = props?.standardTasks
      ?.filter((task) => taskIdSet.has(task.taskId ?? task.id))
      ?.map((task) => ({
        ...(task.id ? { id: task.id } : { taskId: task.taskId }),
        title: task.title,
        // pos: task?.pos === true ? true : false,
        // posFrequency: task?.pos === true ? taskFrequency : 0,
      })) || [];

    const matchedCustomTasks =
      props?.customtaskList
        ?.filter((item) => item.frequency === frequency && props?.shift?.shiftId === item.shift)
        // ?.filter((item) => item.pos === true && item.frequency === frequency)
        ?.map((item) => ({
          taskId: item.taskId,
          title: item.title,
          // pos: item?.pos === true ? true : false,
          // posFrequency: item?.pos === true ? taskFrequency : 0,
          interval: item?.interval,
        })) || [];

    const selectedTaskItems = [...selectedStandardTasks, ...matchedCustomTasks];
    props?.setUpdateMessage(true);

    if (editId !== undefined) {
      props?.updateSummaryListItem(editId, {
        id: editId,
        frequency: frequency,
        tasks: selectedTaskItems,
        shift: props?.shift,
        // taskFrequency: taskFrequency
      });
    } else {
      let newid = getuniqueId("shifttask");
      props?.addSummaryListItem({
        id: newid,
        frequency: frequency,
        tasks: selectedTaskItems,
        shift: props?.shift,
        // taskFrequency: taskFrequency
      });
    }
    clearform();
  };
  const clearform = () => {
    setOpenAddTaskDialog(false);
    setEditMode(false);
    setFrequency("");
    setEditId();
    setDisabledSubStep(2);
  };

  const cancelDialogTask = () => {
    const existingIds = existingTaskDetails?.map(t => t.taskId || t.id) || [];
    const taskIds = tasks || [];

    const added = taskIds?.filter(id => !existingIds?.includes(id));
    const removed = existingIds?.filter(id => !taskIds?.includes(id));

    const hasChanges = added?.length > 0 || removed?.length > 0;

    if (hasChanges) {
      setShowTaskChangePopup(hasChanges);
    } else {
      clearform();
    }
  };

  const onCreateNewTask = (newtask) => {
    const newid = getuniqueId("clienttask");
    const prev = props?.customtaskList || [];

    let newTask = {
      taskId: newid,
      title: newtask?.title?.trim() || "",
      shift: props?.shift?.shiftId,
      description: newtask?.description?.trim() || "",
      startDate: newtask?.startDate || "",
      endDate: newtask?.endDate || "",
      custom: true,
      frequency: frequency,
      interval: newtask?.interval || "30Days",
      // pos: false,
    };

    // if (isAllTasksMode) {
    //   newTask.pos = true;
    // }

    props.setCustomTask([...prev, newTask]);

    // if (isRandomTasksMode) {
    //   props.setStandardTasks((prevStd = []) =>
    //     setSinglePOSTask(prevStd, newid)
    //   );
    // }

    setToggleCustomTaskForm(false);
  };


  useEffect(() => {
    if (!props?.forceTaskRefresh) return;

    setTasks((prev) =>
      prev?.filter((task) => {
        const currentId =
          typeof task === "string" ? task : task?.taskId || task?.id;
        return currentId !== props?.forceTaskRefresh;
      })
    );
  }, [props?.forceTaskRefresh]);

  const onEditTask = (taskId, Task) => {
    props?.setCustomTask([
      ...props?.customtaskList?.map((Item) =>
        Item?.taskId === taskId ? { ...Item, ...Task } : Item
      ),
    ]);
  };
  const removeTask = (Task) => {
    let newTaskList = [
      ...props?.customtaskList?.filter((sitem) => sitem?.taskId !== Task?.taskId),
    ];
    props?.setCustomTask(newTaskList);
  };

  // eslint-disable-next-line no-unused-vars
  const toggleCreateCustomTask = () => {
    setToggleCustomTaskForm(!toggleCustomTaskForm);
  };

  const checkselected = (taskId) => {
    return tasks ? tasks?.some((item) => item === taskId) : false;
  };

  const selectedTaskItems = useMemo(() => {
    if (!tasks || !props?.standardTasks) return [];

    return tasks
      ?.map((id) => {
        const task = props.standardTasks?.find(
          (task) => task.id === id || task.taskId === id
        );
        if (!task) return null;

        if (task.id === id) {
          return { id: task.id, title: task.title };
          // return { id: task.id, title: task.title, pos: task.pos};
        } else {
          return { taskId: task.taskId, title: task.title };
          // return { taskId: task.taskId, title: task.title, pos: task.pos };
        }
      })
      .filter(Boolean);
  }, [tasks, props?.standardTasks]);

  // eslint-disable-next-line no-unused-vars
  const data = [
    ...(props?.SummaryList?.filter(
      (item) => item?.shift?.shiftId === props?.shift?.shiftId
    ) || []),
  ];

  const updatedCustomeTasks = updatedCustomTask
    ? updatedCustomTask?.filter((item) => item?.shift === props?.shift?.shiftId)
    : props?.customtaskList;

  const summariesForThisShift = useMemo(
    () =>
      (props?.SummaryList || [])?.filter(
        (s) => s.shift?.shiftId === props?.shift?.shiftId
      ),
    [props?.SummaryList, props?.shift]
  );

  const frequenciesForShift = useMemo(
    () => Array.from(new Set(summariesForThisShift?.map((s) => s?.frequency))),
    [summariesForThisShift]
  );

  const isOpenTasksVariant = /^opentasks(?:(?:\s*-+\s*|)(?:[1-9]|10))?$/i.test(props?.shift?.title);

  const handleDeleteClick = (task) => {
    setTaskToDelete(task);
    setConfirmDialogOpen(true);
  };

  const handleCancelDialog = () => {
    setShowTaskChangePopup(false);
  };

  const handleConfirmClose = () => {
    setShowTaskChangePopup(false);
    clearform();
  };

  const confirmDeleteTask = () => {
    if (taskToDelete) {
      removeTask(taskToDelete);
    }
    setConfirmDialogOpen(false);
    setTaskToDelete(null);
  };

  const cancelDeleteTask = () => {
    setConfirmDialogOpen(false);
    setTaskToDelete(null);
  };

  const allTasks = [...(selectedTaskItems || []), ...(updatedCustomeTasks || []),];
  const hasTasks = allTasks?.length > 0;
  // eslint-disable-next-line no-unused-vars
  const isAllSelected = hasTasks && allTasks?.every((t) => t?.pos === true);
  // eslint-disable-next-line no-unused-vars
  const isSomeSelected = allTasks?.some((t) => t?.pos === true);

  return (
    <>
      {frequenciesForShift?.length > 0 ? (
        frequenciesForShift?.map((frequency) => {
          const data = summariesForThisShift?.filter(
            (s) => s.frequency === frequency
          );

          return (
            <Card
              key={frequency}
              style={{ overflow: "hidden" }}
              className={`${styles.Card} mv-20 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
            >
              <div className="pv-16 ph-24 d-flex flex-center flex-space-between bg-[#f1f5f9] dark:bg-[#1A1F2C]">
                <div className="d-flex flex-center">
                  <h3
                    className="dark:text-white"
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      margin: "0px",
                    }}
                  >
                    {getDisplayShiftTitle(props?.shift?.title)} {frequency}
                  </h3>
                </div>
                <Button
                  size="sm"
                  variant="outlined"
                  className="bg-[#f1f5f9] dark:bg-gray-800"
                  style={{ border: "1px solid hsl(214.3, 31.8%, 91.4%)" }}
                  onClick={() => {
                    setOpenAddTaskDialog(true);
                    setFrequency(frequency);
                    setDisabledSubStep(3);
                  }}
                >
                  <AddOutlinedIcon
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "4px",
                    }}
                  />{" "}
                  Add Tasks
                </Button>
              </div>

              <CardContent>
                {data?.length > 0 ? (
                  <div className="Summary p-0 mt-30">
                    <TaskSummary
                      SummaryList={data}
                      standardTasks={props?.taskList ?? []}
                      customtaskList={props?.customtaskList ?? []}
                      removeSummaryListItem={props?.removeSummaryListItem}
                      taskFrequencies={props?.taskFrequencies}
                      shift={props?.shift}
                    />
                  </div>
                ) : (
                  <div
                    className={`${styles.noShifts} bg-[#f1f5f9] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
                  >
                    <PlaylistAddCheckOutlinedIcon
                      fontSize="large"
                      style={{ color: "#9ca3af" }}
                    />
                    <h3 className={`${styles.noShiftsTitle} dark:text-white`}>
                      No Task Assigned
                    </h3>
                    <p className={styles.noShiftsText}>
                      Add task to this shift to organize work.
                    </p>
                    <div className="mt-24 d-flex flex-center flex-justify-center">
                      <Button
                        variant="outline"
                        onClick={() => setOpenAddTaskDialog(true)}
                      >
                        <Plus className="w-4 h-4 mr-8" />
                        Add Task
                      </Button>
                    </div>
                    {props?.stepError?.SummaryList && (
                      <div className="mt-15 color-danger">
                        {props?.stepError?.SummaryList}
                      </div>
                    )}
                  </div>
                )}
              </CardContent>
            </Card>
          );
        })
      ) : (
        <Card
          style={{ overflow: "hidden" }}
          className={`${styles.Card} mv-20 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
        >
          <div className="pv-16 ph-24 d-flex flex-center flex-space-between bg-[#f1f5f9] dark:bg-[#1A1F2C]">
            <h3
              className="dark:text-white"
              style={{ fontSize: "16px", fontWeight: "500", margin: "0px" }}
            >
              {getDisplayShiftTitle(props?.shift?.title)}
            </h3>
            <Button
              size="sm"
              variant="outlined"
              className="bg-[#f1f5f9] dark:bg-gray-800"
              style={{ border: "1px solid hsl(214.3, 31.8%, 91.4%)" }}
              onClick={() => {
                setOpenAddTaskDialog(true);
                setDisabledSubStep(3);
              }}
            >
              <AddOutlinedIcon
                style={{ width: "16px", height: "16px", marginRight: "4px" }}
              />{" "}
              Add Tasks
            </Button>
          </div>

          <CardContent>
            <div
              className={`${styles.noShifts} bg-[#f1f5f9] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
            >
              <PlaylistAddCheckOutlinedIcon
                fontSize="large"
                style={{ color: "#9ca3af" }}
              />
              <h3 className={`${styles.noShiftsTitle} dark:text-white`}>
                No Task Assigned
              </h3>
              <p className={styles.noShiftsText}>
                Add task to this shift to organize work.
              </p>
              <div className="mt-24 d-flex flex-center flex-justify-center">
                <Button
                  variant="outline"
                  onClick={() => setOpenAddTaskDialog(true)}
                >
                  <Plus className="w-4 h-4 mr-8" />
                  Add Task
                </Button>
              </div>
              {props?.stepError?.SummaryList && (
                <div className="mt-15 color-danger">
                  {props?.stepError?.SummaryList}
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      )}

      <Dialog open={openAddTaskDialog} onClose={!openAddTaskDialog} className="dialogWidth">
        <DialogContent>
          <div className="d-flex flex-space-between">
            <h3
              className="mb-20 color-newBlack dark:text-white"
              style={{ fontSize: "18px", fontWeight: "600" }}
            >
              Add {getDisplayShiftTitle(props?.shift?.title)}
            </h3>
            <X className="h-4 w-4 dark:text-white" onClick={clearform} />
          </div>
          <div
            className={
              isMobile
                ? "pb-20 d-flex flex-direction-column dark:bg-[#1A1F2C]"
                : "pb-20 d-flex dark:bg-[#1A1F2C]"
            }
          >
            <div className="d-flex delete" style={{ width: isMobile ? "" : "50%" }}>
              <div className="mr-20">
                <div className="stepSectionContent">
                  <div className="taskGroupSelect">
                    <h4
                      className="mb-8 color-newBlack dark:bg-[#1A1F2C] dark:text-white"
                      style={{ fontSize: "14px", fontWeight: "500" }}
                    >
                      Task Frequency{" "}
                    </h4>
                    <div style={{ minWidth: isMobile ? "" : "480px" }}>
                      <SingleSelect
                        value={frequency ? frequency : ""}
                        className={`field`}
                        name={"frequency"}
                        onChange={onChangeFrequency}
                        options={
                          isOpenTasksVariant
                            ? fitfunn.map((item) => {
                              return {
                                label: `${item}`,
                                value: item,
                              };
                            })
                            : [...fitfunnt].map((item) => {
                              return {
                                label: `${item}`,
                                value: item,
                              };
                            })
                        }
                      />
                    </div>
                  </div>
                  {typeof errorMessage?.frequency !== "undefined" &&
                    errorMessage?.frequency !== "" && (
                      <FormHelperText className="small error color-danger">
                        {errorMessage?.frequency}
                      </FormHelperText>
                    )}
                </div>
                {item === null ? (
                  <CreateClientTask
                    Task={{}}
                    shifttitle={props?.shift?.title}
                    onCreateNewTask={onCreateNewTask}
                    frequency={frequency}
                  />
                ) : (
                  <CreateClientTask
                    frequency={frequency}
                    taskId={item?.taskId}
                    Task={item}
                    shifttitle={props?.shift?.title}
                    OnEditTask={onEditTask}
                    onCreateNewTask={onCreateNewTask}
                  />
                )}
                <div className="mt-12 dark:bg-[#1A1F2C]">
                  <h4
                    className="mb-8 color-newBlack dark:text-white"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                  >
                    {frequency ? `${frequency} Tasks` : "Selected Tasks"}
                  </h4>
                  <div className=" d-flex border rounded-md p-2 min-h-[120px] max-h-[240px] overflow-y-auto dark:bg-[#1A1F2C] dark:text-white dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0">
                    {frequency &&
                      (props?.customtaskList?.length > 0 ||
                        selectedTaskItems?.length > 0) ? (
                      <div
                        style={{ width: isMobile ? "280px" : "480px" }}
                        className="dark:bg-[#1A1F2C] dark:text-white"
                      >
                        <div
                          className="d-flex flex-direction-column mt-10 dark:bg-[#1A1F2C] dark:text-white"
                          style={{ gap: "6px" }}
                        >
                          {/* {isSelectedTasksMode && (
                          <div
                              className="d-flex flex-center flex-justify-center pc-6 ph-10 bg-[#F1F5F9] dark:bg-[#111827] dark:text-white"
                              style={{
                                fontSize: "14px",
                                borderRadius: "6px",
                                fontWeight: 600,
                                marginBottom: "6px",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isAllSelected}
                                ref={(el) => {
                                  if (el) {
                                    el.indeterminate = isSomeSelected && !isAllSelected;
                                  }
                                }}
                                onChange={(e) => {
                                    const checked = e.target.checked;

                                    selectedTaskItems?.forEach((item) =>
                                      onCheckTask(
                                        { target: { checked } },
                                        item,
                                        "selected"
                                      )
                                    );

                                    updatedCustomeTasks?.forEach((item) =>
                                      onCheckTask(
                                        { target: { checked } },
                                        item,
                                        "custom"
                                      )
                                    );
                                }}
                                style={{ accentColor: "green" }}
                                className="mr-10"
                              />

                              <span style={{ flexGrow: 1, padding:"4px" }}>
                                Select all tasks
                              </span>
                          </div>
                        )} */}

                          {selectedTaskItems?.map((item, index) => (
                            <div
                              key={index}
                              className="d-flex flex-center flex-justify-center pc-6 ph-10 bg-[#F8FAFC] dark:bg-[#1A1F2C] dark:text-white"
                              style={{ fontSize: "14px", borderRadius: "6px" }}
                            >
                              {/* {props?.settingsData?.[0]?.proofOfService === true && (
                              <input
                                type="checkbox"
                                checked={!!item.pos}
                                onChange={(e) => isSelectedTasksMode && onCheckTask(e, item, "selected")}
                                style={{ accentColor: "green" }}
                                className="mr-10"
                              />
                            )}

                            {props?.settingsData?.[0]?.proofOfService === true && item?.pos && (
                                <Camera
                                  className="mh-5"
                                  size={16}
                                  style={{
                                    color: "#16a34a",
                                  }}
                                />
                              )} */}
                              <span style={{ flexGrow: "1" }}>
                                {item.title}
                              </span>
                              <span
                                className="ml-10 dark:text-white text-[#02081]"
                                style={{
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  onChangeTask(
                                    { target: { checked: false } },
                                    item
                                  )
                                }
                              >
                                <CloseOutlinedIcon fontSize="small" />
                              </span>
                            </div>
                          ))}
                        </div>
                        <div
                          className="d-flex flex-direction-column mt-10 dark:bg-[#1A1F2C] dark:text-white"
                          style={{ gap: "6px" }}
                        >
                          {updatedCustomeTasks?.map((item, index) => (
                            <div
                              key={index}
                              className="d-flex flex-center justify-space-between pc-6 ph-10 bg-[#F8FAFC] dark:bg-[#1A1F2C] dark:text-white"
                              style={{ fontSize: "14px", borderRadius: "6px" }}
                            >
                              {/* {props?.settingsData?.[0]?.proofOfService === true && (
                              <input
                                type="checkbox"
                                checked={!!item.pos}
                                onChange={(e) => isSelectedTasksMode && onCheckTask(e, item, "custom")}
                                style={{accentColor: "green"}}
                                className="mr-10"
                              />
                            )}

                            {props?.settingsData?.[0]?.proofOfService === true && item?.pos && (
                                <Camera
                                  className="mh-5"
                                  size={16}
                                  style={{
                                    color: "#16a34a",
                                  }}
                                />
                              )} */}

                              <Tooltip
                                title={
                                  item.title.charAt(0).toUpperCase() + item.title.slice(1).toLowerCase() +
                                  (item?.interval ? ` (${item?.interval}d)` : " (30d)")
                                }
                                placement="bottom-start"
                                arrow
                              >
                                <span
                                  style={{
                                    flexGrow: 1,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {(() => {
                                    const text =
                                      item?.title?.charAt(0)?.toUpperCase() + item?.title?.slice(1)?.toLowerCase();
                                    const label = item?.interval ? ` (${item?.interval}d)` : " (30d)";
                                    const fullText = text + label;

                                    return text?.length > 30
                                      ? text?.slice(0, 30) + "..." + label
                                      : fullText;
                                  })()}
                                </span>
                              </Tooltip>
                              <span className="d-flex flex-center">
                                {(item?.startDate || item?.endDate) && (
                                  <span className="ml-5">
                                    ({item?.startDate || ""}
                                    {item?.startDate && item?.endDate && " - "}
                                    {item?.endDate || ""})
                                  </span>
                                )}

                                <Tooltip title="Delete this task" arrow>
                                  <span
                                    className="mh-10 dark:text-white text-[#02081]"
                                    style={{
                                      fontWeight: "bold",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleDeleteClick(item)}
                                  >
                                    <CloseOutlinedIcon fontSize="small" />
                                  </span>
                                </Tooltip>

                                <Tooltip title="Change this task" arrow>
                                  <div
                                    className={classes?.infobutton}
                                    onClick={() => setItem(item)}
                                  >
                                    <FontAwesomeIcon icon={faPencilAlt} />
                                  </div>
                                </Tooltip>
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex flex-center flex-justify-center dark:bg-[#1A1F2C]"
                        style={{
                          minWidth: "100%",
                          color: "#9CA3AF",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        No Task Selected
                      </div>
                    )}
                  </div>
                </div>

                {/* {props?.settingsData?.[0]?.proofOfService === true && (
                <>
                <div className="mt-20 max-w-xl rounded-xl border border-gray-300 bg-white p-18 shadow-sm dark:bg-[#1A1F2C]">
                  <div className="mb-12 flex items-center justify-between dark:text-white">
                    <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                      Proof of Service – {props?.settingsData?.[0]?.taskOption === "all_tasks" ? "All Tasks" : props?.settingsData?.[0]?.taskOption === "selected_tasks" ? "Some Tasks" : "Random Tasks"}
                    </h3>
                    <span className="text-sm font-medium text-gray-700 dark:text-white">
                      {taskFrequency}%
                    </span>
                  </div>

                  <Slider
                    min={0}
                    max={100}
                    step={5}
                    value={[taskFrequency]}
                    onValueChange={(values) => setTaskFrequency(values[0])}
                    className="w-full"
                    data-zero={taskFrequency === 0}
                  />

                  <p className="mt-12 text-sm text-gray-600 dark:text-white">
                    Set the default percentage of visits that require proof of service (0–100%).
                  </p>
                </div>
                  </>
              )} */}

                {/* <CreateClientTask
                  Task={{}}
                  shifttitle={props?.shift?.title}
                  onCreateNewTask={onCreateNewTask}
                  frequency={frequency}
                /> */}
              </div>
            </div>
            <div className="border-l pl-10 dark:bg-[#1A1F2C] dark:text-white" style={{ width: isMobile ? "" : "60%" }}>
              {!isOpenTasksVariant && (
                <TaskLists
                  disabled={disabledsubSteps < 3}
                  taskList={props?.standardTasks}
                  serviceTypes={props?.serviceTypes}
                  search={true}
                  handleTasksCheckChange={onChangeTask}
                  checkselected={checkselected}
                />
              )}
            </div>
          </div>

          <div className="d-flex flex-center flex-space-between dark:bg-[#1A1F2C]">
            {frequency && (
              <div style={{ color: "#6B7280" }}>
                {tasks?.length || 0}{" "}
                {frequency ? `${frequency} Task` : "Selected Task"}
              </div>
            )}
            <div className="mt-20 mb-10 d-flex flex-justify-end dark:bg-[#1A1F2C]">
              <Button variant="outline" onClick={cancelDialogTask}>
                Cancel
              </Button>
              <Button
                className="bg-green color-white ml-15"
                color="primary"
                variant="contained"
                onClick={submitTaskItem}
              >
                <CheckSquare className="mr-8 h-4 w-4" />{" "}
                {clientId ? "Update to Task" : "Add to Task"}
              </Button>
            </div>
          </div>
          {confirmDialogOpen && (
            <DialogComponent
              buttonLabel={""}
              buttonClassName="hidden"
              ModalTitle="Delete Task"
              ModalDescription="Are you sure you want to delete this task?"
              ModalContent={<div />}
              ModalActionsCancel={cancelDeleteTask}
              ModalActionsSave={confirmDeleteTask}
              CancelLabel="No"
              SaveLabel="Yes"
              dialogProps={{
                open: confirmDialogOpen,
                onClose: cancelDeleteTask,
              }}
            />
          )}

          {showTaskChangePopup && (
            <CommonConfirmationDialog
              open={showTaskChangePopup}
              onConfirm={handleConfirmClose}
              onClose={handleCancelDialog}
              title={"Unsaved Task Changes"}
              message={"You’ve made changes to your task list that haven’t been saved. Are you sure you want to cancel? All unsaved changes will be lost."}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateTaskItem;
